<template>
	<div class="inherit">
		<div class="ht_box1">
			<div class="ht_box1_con">
				<p data-aos="fade-up">
					<img src="@/images/gongyi/gy_img7.png" />
				</p>
				<ul class="tj_list flex1" data-aos="fade-up" data-aos-duration="3000">
					<li class="tj_item flex2">
						<div class="tj_item_left flex3">
							<span>30</span>
							<div>
								<p>十</p>
								<p>年</p>
							</div>
						</div>
						<div class="tj_item_right">
							<p>30多年来，剑南春积极推进企业</p>
							<p>科研工作向高层次、前瞻性发展。</p>
						</div>
					</li>
					<li class="tj_item flex2">
						<div class="tj_item_left flex3">
							<span>4</span>
							<div>
								<p>十</p>
								<p>亿</p>
							</div>
						</div>
						<div class="tj_item_right">
							<p>集团不断加大对科研力量投入，</p>
							<p>科研装备投入已达4亿元。</p>
						</div>
					</li>
					<li class="tj_item flex2">
						<div class="tj_item_left flex3">
							<span>30</span>
							<div>
								<p>十</p>
								<p>项</p>
							</div>
						</div>
						<div class="tj_item_right">
							<p>重大科技进步成果奖，对传统酿造</p>
							<p>酒业的科技创新做出了突出贡献。</p>
						</div>
					</li>
				</ul>
				<div class="build" data-aos="fade-up">
					<img class="bd_img" src="@/images/gongyi/gy_img8.png" />
					<div class="bd_list flex2">
						<span class="bd_item1">1997年通过四川省级技术中心认定</span>
						<span class="bd_item1">2002年公司设立博士后科研工作站</span>
						<!-- <span class="bd_item2">2008年通过国家五部委认定为“国家认定企业技术中心”</span> -->
						<span class="bd_item1">2013年设立德阳院士专家工作站</span>
						<span class="bd_item1">2014年设立了四川省品酒技能大师工作室</span>
						<span class="bd_item2">2017年设立了国家级品酒技能大师工作室</span>
					</div>
				</div>
			</div>
		</div>
		<div class="ht_box2">
			<div class="ht_box2_con">
				<p data-aos="fade-up">
					<img src="@/images/gongyi/jytd.png" />
				</p>
				<p class="hb_tit" data-aos="fade-up">
					人才是企业之本，高素质、专业化的科研人员团队是剑南春品质的坚实基础。
				</p>
				<ul class="expert_list flex1" data-aos="fade-up">
					<li class="expert_item">
						<div class="tt_con">
							<div class="tt_img">
								<img src="@/images/gongyi/zj1.png" />
							</div>
							<div class="tj_item flex2">
								<div class="tj_item_left flex3">
									<span>7</span>
									<div>
										<p style="color: transparent">十</p>
										<p>位</p>
									</div>
								</div>
								<div class="tj_item_right">
									<p>享受国务院政府特殊津贴在职专家</p>
								</div>
							</div>
						</div>
					</li>
					<li class="expert_item">
						<div class="tt_con">
							<div class="tt_img">
								<img src="@/images/gongyi/zj2.png" />
							</div>
							<div class="tj_item flex2">
								<div class="tj_item_left flex3">
									<span>40</span>
									<div>
										<p>十</p>
										<p>位</p>
									</div>
								</div>
								<div class="tj_item_right">
									<p>
										包括中国酿酒大师、国家级专家委员会专家、中国首席评酒师和中国白酒大师、突出贡献优秀专家等在内的白酒专家教授。
									</p>
								</div>
							</div>
						</div>
					</li>
					<li class="expert_item">
						<div class="tt_con">
							<div class="tt_img">
								<img src="@/images/gongyi/zj3.png" />
							</div>
							<div class="tj_item flex2">
								<div class="tj_item_left flex3">
									<span>400</span>
									<div>
										<p>十</p>
										<p>位</p>
									</div>
								</div>
								<div class="tj_item_right">
									<p>
										高级智能型和高级技能型人才，中级科技人员和中级技能人才占本岗位人员的60%以上。
									</p>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="ht_box3">
			<div class="ht_box3_con">
				<img data-aos="fade-up" class="ht3_tit" src="@/images/gongyi/cx.png" />
				<div data-aos="fade-up" class="ht3_p">
					<p>
						剑南春作为中国白酒行业科技发展的引领者，科研技术水平继续保持国内外行业中的领先地位，
					</p>
					<p>取得国家、省、市各级科技奖励30多项，有效专利350件，</p>
					<p>
						这些科技成果为中国白酒业技术创新和核心技术的形成提供了有力保障。
					</p>
				</div>
				<ul data-aos="fade-up" class="cx_list flex1">
					<li class="cx_item">
						<img src="@/images/gongyi/cx_img1.png" />
						<div class="ctm_text">
							<p class="ctm_text_p1">挥发系数鉴别年份酒新方法</p>
							<p class="ctm_text_p2">
								剑南春的科研团队在徐占成总工程师的带领下，发明了“挥发系数鉴别年份酒的方法”，这项重大科研成果不仅填补了国内外年份酒鉴别方法的空白，而且成功的破解了困扰酒类行业多年的世界性技术难题，在推进中国白酒的国际化进程中做出重大贡献。
							</p>
						</div>
					</li>
					<li class="cx_item">
						<img src="@/images/gongyi/cx_img2.png" />
						<div class="ctm_text">
							<p class="ctm_text_p1">酒体风味设计学</p>
							<p class="ctm_text_p2">
								剑南春在白酒风味特征形成规律及生成机理研究的基础上，开创性地建立了酒体风味设计学的科学体系。酒体风味设计是对我国白酒行业技术创新的理论性总结，对于提升全行业总体科学技术水平具有重要意义和深远影响，是中国白酒工业工艺技术继承、创新和发展的里程碑。
							</p>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="ht_box4">
			<div class="ht_box4_con flex1">
				<div class="qu_left flex3" data-aos="fade-up">
					<div class="ft_img">
						<img src="@/images/gongyi/qu1.png" />
					</div>
					<div class="ft_text">
						<p class="txt_p1">曲药天书</p>
						<p class="txt_p2">
							剑南春应用现代分子生物学技术，破译了浓香型白酒主要呈香呈味物质的生成与曲药微生物群系的潜在关系，选育出多株代谢酿酒生物酶和健康因子的特殊功能微生物，在保持酒体典型风味特征不变的基础上，大幅提高了酒体中关键风味物质和健康因子含量，确保了产品安全性和优质品率。
						</p>
						<br />
						<p class="txt_p2">
							在继承传统制曲模式的同时，剑南春搭建了曲药质量等级鉴定体系制，创立了一套大曲药工艺技术质量标准，从根本上改变了传统制曲操作“靠经验、凭感觉”的不确定性，这是传统中温大曲生产工艺技术的重大升华，为智能化制曲生产提供了有力技术支撑。
						</p>
					</div>
				</div>
				<div class="qu_right" data-aos="fade-up">
					<p class="txt_p1">老窖新生</p>
					<p class="txt_p2">
						剑南春通过对天益老号窖池中的功能菌株进行定性研究，发现并命名浓香型酒主体香味物质的功能菌株——“耳蜗形梭菌”，这为剑南春独特风味特征的形成奠定了基础。该成果荣获中国食品工业协会科学技术进步一等奖。在剑南春传统酿造技艺发展的过程中，利用现代生物技术分离选育老窖关键功能微生物菌群，使传统技艺与科技创新有机融合，形成其独特传承体系，确保了剑南春酒在不断发展过程中保持了高贵典雅的时尚品质。
					</p>
					<br />
					<div class="ft_img2">
						<img src="@/images/gongyi/qu2.png" />
					</div>
				</div>
			</div>
		</div>
		<div class="ht_box5">
			<div class="ht_box5_con" data-aos="fade-up">
				<p class="txt_p1">智能评价</p>
				<p class="txt_p3">
					剑南春研究团队发明了“秒持值衡定评酒法”并研究了“剑南春名优白酒质量评价体系”，打破了传统的感官评酒方式，使“只可意会，不可言传”的传统感官尝评方法能够被数据化、标准化的科学方法所代替，将评酒专家们的评酒智能、理化数据转化成一个高智能化的评价体系，达到了国内白酒行业领先水平，这是酿酒行业的重大技术创新。
				</p>
			</div>
			<div class="rec_box">
				<record></record>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
};
</script>

<style lang="scss">
.txt_p1 {
	text-align: left;
	color: #c0494b;
	font-size: 24px;
	margin-bottom: 28px;
	text-align: left;
}
.txt_p2 {
	color: #333;
	font-size: 14px;
	line-height: 2.1;
	text-align: left;
}
.txt_p3 {
	text-align: left;
	font-size: 15px;
	line-height: 2.1;
	color: #333;
}
.inherit {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	margin-top: 76px;
    min-width: 950px;
	padding-bottom: 74px;
	.ht_box1 {
		padding: 80px 20px 116px;
		background-image: url("../../images/gongyi/bgimg2.png");
		background-repeat: no-repeat;
		background-position: top;
		background-color: #f0eeef;
		.ht_box1_con {
			max-width: 1280px;
            min-width: 950px;
			margin: 0 auto;
			.tj_list {
				margin-top: 30px;
				.tj_item {
					.tj_item_left {
						font-weight: 700;
						span {
							color: #d0393b;
							font-size: 60px;
							display: block;
							margin-right: 6px;
							text-shadow: #fff 1px 0 0, #fff 0 1px 0, #fff -1px 0 0,
								#fff 0 -1px 0;
						}
						div {
							color: #d0393b;
							font-size: 18px;
							text-shadow: #fff 1px 0 0, #fff 0 1px 0, #fff -1px 0 0,
								#fff 0 -1px 0;
						}
					}
					.tj_item_right {
						color: #fff;
						font-size: 16px;
						line-height: 1.8;
						margin-left: 12px;
						p {
							text-align: left;
						}
					}
				}
			}
		}
		.build {
			text-align: center;
			margin-bottom: 34px;
			box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
			position: relative;
			.bd_img {
				width: 100%;
			}
			.bd_list {
				position: absolute;
				width: 100%;
				left: 0;
				bottom: 10px;
				z-index: 9;
				flex-wrap: wrap;
				span {
					display: inline-block;
					color: #fff;
					font-size: 16px;
					text-align: center;
					height: 49px;
					line-height: 49px;
					background-color: rgba(212, 50, 53, 0.7);
					margin: 0 16px 14px;
				}
				.bd_item1 {
					width: 320px;
				}
				.bd_item2 {
					width: 426px;
				}
			}
		}
	}
	.ht_box2 {
		background-image: url("../../images/gongyi/gy_img9.png");
		background-repeat: no-repeat;
		background-size: cover;
		padding: 70px 20px 116px;
		.ht_box2_con {
			max-width: 1500px;
			margin: 0 auto;
			.hb_tit {
				color: #666;
				font-size: 18px;
				text-align: center;
				line-height: 1.8;
				margin-bottom: 56px;
				margin-top: 20px;
			}
			.expert_list {
				margin: 0 -25px;
				.expert_item {
					width: 33.3%;
					padding: 0 25px;
					.tt_con {
						.tt_img {
							transition: all 0.5s ease;
							overflow: hidden;
							img {
								width: 100%;
								display: block;
							}
						}
						.tj_item {
							box-sizing: border-box;
							background-color: #f7f6f6;
							padding: 15px 20px;
							height: 90px;
							overflow: hidden;
							.tj_item_left {
								font-weight: 700;
								span {
									color: #c0494b;
									font-size: 60px;
									font-weight: 700;
									margin-right: 6px;
									line-height: 1;
								}
								div {
									color: #c0494b;
									font-size: 18px;
									font-weight: 700;
								}
							}
							.tj_item_right {
								flex: 1;
								margin-left: 10px;
								color: #333;
								font-size: 14px;
								p {
									text-align: left;
								}
							}
						}
					}
				}
			}
		}
	}
	.ht_box3 {
		background-color: #fff;
		padding: 56px 20px 112px;
		.ht_box3_con {
			max-width: 1710px;
			margin: 0 auto;
			.ht3_tit {
				margin-bottom: 20px;
			}
			.ht3_p {
				color: #666;
				font-size: 18px;
				text-align: center;
				line-height: 1.8;
				margin-bottom: 56px;
			}
			.cx_list {
				.cx_item {
					width: 42.14%;
					position: relative;
					img {
						width: 100%;
					}
					.ctm_text {
						position: absolute;
						right: 0;
						left: 0;
						bottom: 0;
						background-color: hsla(0, 0%, 100%, 0.8);
						padding: 22px 32px;
						.ctm_text_p1 {
							color: #c0494b;
							font-size: 24px;
							margin-bottom: 15px;
							text-align: left;
						}
						.ctm_text_p2 {
							color: #333;
							font-size: 15px;
							line-height: 30px;
							text-align: left;
						}
					}
				}
			}
		}
	}
	.ht_box4 {
		background-color: #f0eeef;
		padding: 125px 20px 146px;
		.ht_box4_con {
			max-width: 1780px;
			margin: 0 auto;
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
			.qu_left {
				width: 48.8%;
				align-items: flex-start;
				.ft_img {
					width: 58%;
                    img{
                        width: 100%;
                    }
				}
				.ft_text {
					flex: 1;
					padding-left: 30px;
				}
			}
			.qu_right {
				width: 39.1%;
				.ft_img2 {
					margin-top: 38px;
				}
			}
		}
	}
	.ht_box5 {
		padding: 232px 20px 10px 0;
		background: url("../../images/gongyi/bgimg5.png") no-repeat 50%;
		background-size: cover;
		.ht_box5_con {
			max-width: 762px;
			margin: 0 auto;
			background-color: hsla(0, 0%, 100%, 0.7);
			padding: 60px 50px 80px;
			position: relative;
			box-sizing: border-box;
			.txt_p1 {
				text-align: center;
			}
		}
		.rec_box {
			margin-top: 250px;
		}
	}
}
</style>